// VolumeController.js
'use strict';
import { connect } from 'react-redux';
import setPlayerData from '../action/setPlayerData.js';
import getOperationData from '../selector/getOperationData.js';
import VolumeController from '../component/VolumeController.jsx';

const mapStateToProps = state => {
  const volume = getOperationData(state, ['player'], 'volume');
  const isMuted = getOperationData(state, ['player'], 'isMuted');
  const isDragToMute = getOperationData(state, ['player'], 'isDragToMute');
  const volumeBeforeDragToMute = getOperationData(
    state,
    ['player'],
    'volumeBeforeDragToMute'
  );

  return { volume, isMuted, isDragToMute, volumeBeforeDragToMute };
};

const mapDispatchToProps = dispatch => {
  return {
    setPlayerData: data => dispatch(setPlayerData(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(VolumeController);
